// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__r2Nij","right":"styles_right__2zWR2"};